module.exports = __webpack_public_path__ + "img/path-8.5513a16b.svg";